import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, getUsernameJwt, isExpiredJwt, renderRedirect, multipartHeaders, 
    getJwtFromCookies, setMutipartTokenHeader } from "../../module_auth/AuthService"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from "react-router-dom";
import { ToastMessage } from "../../component/common/Toast"
import { ImageFileUploadButton } from "../common/FileUploadButton"

export function NewsRegAdmin() {
    //뉴스상세
    const [mbrId, setMbrId] = useState("");
    const [newsTitle, setNewsTitle] = useState("");
    const [summary, setSummary] = useState("");
    const [value, setValue] = useState('');
    
    const [fileData, setFileData] = useState('');
    const [fileExist, setFileExist] = useState(false);

    const [slug, setSlug] = useState("");
    const [fileSource, setFileSource] = useState("");
    //End 뉴스상세

    const [jwtToken, setJwtToken] = useState("");
    const [redirect, setRedirect] = useState(false);
    const [accessToken, setAccessToken] = useState("");

    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    useEffect(() => {
        if(getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())){
            setRedirect(true)
        } else {
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))
        }
    }, []);

    function clickSubmit(event) {
        event.preventDefault();

        const formData = new FormData()
        formData.append('File', fileData)
        
        let jsonStr = JSON.stringify({
            mbrId: mbrId,
            newsTitle:newsTitle,
            summary:summary,
            newsContent:value,
            fileSource:fileSource,
            slug:slug
        })
        formData.append('JsonStr', jsonStr)

        let headers = multipartHeaders
        setMutipartTokenHeader(getJwtFromCookies())

        fetch(basePort + '/post/news', 
            {method:'post', headers,
                      body:formData})
                    .then(response => response.json())
                    .then(response => {
                    if(response.validRequest){
                        fadeOutToast(response.validationMessage)
                        setTimeout(function() {
                            moveTo()
                        }.bind(this), 3000)
                    } else {
                        fadeOutToast(response.validationMessage)
                    }
        }).catch(function(error) {
            console.log(error);
        });
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    let navigate = useNavigate();
    function moveTo() {
        let url = "/news_list_admin"
        navigate(url);
    }

    function handleNewsTitle(event) {
        setNewsTitle(event.target.value);
    }

    function handleImage(){
        //nothing
    }

    function removeFile(){
        document.getElementById("chooseFile").value = ""
        setFileData("")
        setFileExist(false)
    }

    function handleFileSource(event) {
        setFileSource(event.target.value);
    }

    function handleSlug(event) {
        setSlug(event.target.value);
    }

    return (
        <div>
            {renderRedirect(redirect, '/login')}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><span>독일뉴스</span></li>
                        <li class="breadcrumb-item"><span>뉴스등록</span></li>
                    </ol>
                    <form><label class="form-label" style={{textAlign: 'left', fontWeight: 'bold'}}>제목</label>
                        <input class="form-control" type="text" onChange={handleNewsTitle}/>
                    </form>
                    <form style={{marginTop: '10px', marginRight: '0', marginLeft: '0'}}>
                        <label class="form-label" style={{textAlign: 'left', fontWeight: 'bold'}}>요약</label>
                        <div class="container" style={{height:'350px', marginBottom:'10px'}}>
                        <ReactQuill theme="snow" value={summary} onChange={setSummary}
                            style={{height: '300px', marginBottom:'10px'}}
                            modules={{
                                toolbar: {
                                    container: [
                                        [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                        [{ size: [] }],
                                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                        [{ list: 'ordered' }, { list: 'bullet' }],
                                        ['image'],
                                        ['clean'],
                                        ['code-block']
                                    ],
                                    handlers: {
                                        image: handleImage(),
                                    },
                                },
                                
                            }}
                        />
                        </div>
                    </form>
                    <form style={{marginTop: '10px', marginRight: '0', marginLeft: '0'}}>
                        <label class="form-label" style={{textAlign: 'left', fontWeight: 'bold'}}>내용</label>
                        <div class="container" style={{height:'350px', marginBottom:'10px'}}>
                        <ReactQuill theme="snow" value={value} onChange={setValue}
                            style={{height: '300px', marginBottom:'10px'}}
                            modules={{
                                toolbar: {
                                    container: [
                                        [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                        [{ size: [] }],
                                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                        [{ list: 'ordered' }, { list: 'bullet' }],
                                        ['image'],
                                        ['clean'],
                                        ['code-block']
                                    ],
                                    handlers: {
                                        image: handleImage(),
                                    },
                                },
                                
                            }}
                        />
                        </div>
                    </form>
                    <form><label class="form-label" style={{marginTop:'10px', textAlign: 'left', fontWeight: 'bold'}}>SLUG</label>
                        <input class="form-control" type="text" onChange={handleSlug}/>
                    </form>
                    <form><label class="form-label" style={{marginTop:'10px', textAlign: 'left', fontWeight: 'bold'}}>파일출처</label>
                        <input class="form-control" type="text" onChange={handleFileSource}/>
                    </form>
                    <ImageFileUploadButton 
                        setFileData={setFileData}
                        setFileExist={setFileExist}
                        removeFile={removeFile}
                        fileExist={fileExist}
                    />
                    <form style={{textAlign:'center', marginBottom:'10px', marginTop:'30px'}}>
                        <button class="btn btn-secondary" type="button" onClick={moveTo} style={{marginRight: '5px'}}>취소하기</button>
                        <button class="btn btn-primary" type="button" onClick={clickSubmit}>저장하기</button>
                    </form>
                    <ToastMessage show={showToast} msg={msgToast}/>
                    </div>
                </section>
            </main>
        </div>
    );
}